<template>
  <div class="right-data-bicycle-root">
    <div ref="tripInfoPopup" class="trip-info-popup" :style="panelStyle">
      <!-- 与 RightData.vue 标签区域一致：展开条 + 表格区 -->
      <div class="bicycle-tab-panel-wrap" :style="sectionWrapStyle">
        <div class="expand-controls">
          <div
          v-if="isExpandedNum == 1"
      class="expand-btn"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="collapsePanel(2)"
    >
      <i style="color: #fff;" class="el-icon-caret-top"></i>
    </div>
    <div
          v-if="isExpandedNum == 1"
      class="expand-btn"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="collapsePanel(3)"
    >
      <i style="color: #fff;" class="el-icon-caret-bottom"></i>
    </div>
        </div>
        <el-table
          :data="pagedTableRows"
          border
          stripe
          class="right-data-el-table"
          :style="tableCombinedStyle"
          @row-click="onTableRowClick"
        >
          <el-table-column prop="plate" label="车牌号" width="112" show-overflow-tooltip />
          <el-table-column v-if="waybillMode" prop="routeName" label="路线名称" min-width="130" show-overflow-tooltip />
          <el-table-column v-if="waybillMode" prop="waybillNo" label="运单编号" min-width="150" show-overflow-tooltip />
          <el-table-column v-if="waybillMode" prop="startUnit" label="发货单位" min-width="170" show-overflow-tooltip />
          <el-table-column v-if="waybillMode" prop="endUnit" label="收货单位" min-width="170" show-overflow-tooltip />
          <el-table-column prop="fixTime" label="定位时间" width="164" show-overflow-tooltip />
          <el-table-column prop="speed" label="速度" width="86" align="right" />
          <el-table-column v-if="!waybillMode" prop="direction" label="方向" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" width="86" show-overflow-tooltip />
          <el-table-column v-if="waybillMode" prop="totalMileage" label="规划里程" width="104" align="right" />
          <el-table-column v-if="waybillMode" prop="remainingMileage" label="剩余里程" width="104" align="right" />
          <el-table-column v-if="waybillMode" prop="estimatedArriveTime" label="预计到达时间" width="164" show-overflow-tooltip />
          <el-table-column v-if="!waybillMode" prop="mileage" label="总里程" align="right" />
          <el-table-column v-if="!waybillMode" prop="lngLat" label="经纬度" show-overflow-tooltip />
          <el-table-column prop="location" label="位置信息" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="location-link">{{ scope.row.location }}</span>
            </template>
          </el-table-column>
            </el-table>
        <el-pagination
          class="bicycle-pagination"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="tableRows.length"
          @size-change="onSizeChange"
          @current-change="onPageChange"
        />
            </div>
    </div>
    <div class="expand-controls-fiex" :style="mapPanelAnchorStyle">
      <div
        v-if="isExpandedNum == 2"
        class="expand-btn expand-controls-top"
        role="button"
        tabindex="0"
        aria-label="展开或收起侧栏"
        @click="collapsePanel(1)"
      >
        <i style="color: #fff;" class="el-icon-caret-bottom"></i>
      </div>
      <div
        v-if="isExpandedNum == 3"
        class="expand-btn expand-controls-bottom"
        role="button"
        tabindex="0"
        aria-label="展开或收起侧栏"
        @click="collapsePanel(1)"
      >
        <i style="color: #fff;" class="el-icon-caret-top"></i>
      </div>
    </div>
  </div>
</template>

<script>
import coordtransform from '@/WGS84.js'
import { formatDirectionText } from '@/utils/vehicleHeading'

function lonLatToGcjLikeTransport(lon, lat) {
  const nlon = Number(lon)
  const nlat = Number(lat)
  if (Number.isNaN(nlon) || Number.isNaN(nlat)) return [0, 0]
  const useScaled = Math.max(Math.abs(nlon), Math.abs(nlat)) > 10000
  if (useScaled) {
    const lonWgs84 = nlon / 600000.0
    const latWgs84 = nlat / 600000.0
    return coordtransform.wgs84togcj02(lonWgs84, latWgs84)
  }
  return [nlon, nlat]
}

/** gtm 串 yyyymmdd/hhmmss → yyyy-MM-dd HH:mm:ss；已是标准格式则原样返回 */
function formatGtmTime(gtm) {
  if (gtm == null || gtm === '') return '—'
  const s = String(gtm).trim()
  if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}$/.test(s)) return s
  if (s.length < 15 || s.charAt(8) !== '/') return s || '—'
  try {
    const datePart = s.substring(0, 8)
    const timePart = s.substring(9)
    const year = datePart.substring(0, 4)
    const month = datePart.substring(4, 6)
    const day = datePart.substring(6, 8)
    const hour = timePart.substring(0, 2)
    const minute = timePart.substring(2, 4)
    const second = timePart.substring(4, 6)
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  } catch (e) {
    return '—'
  }
}

function resolveFixTimeFromItem(item) {
  if (!item || typeof item !== 'object') return '—'
  if (item.utc != null && item.utc !== '') {
    return formatGtmTime(utcToGtmFromApi(item.utc))
  }
  if (item.gtm != null && item.gtm !== '') {
    return formatGtmTime(item.gtm)
  }
  if (item.fixTime != null && String(item.fixTime).trim() !== '') {
    return formatGtmTime(item.fixTime)
  }
  return '—'
}

function parseRunRouteSpdKm(item, preserveUnknown = false) {
  const unknown = preserveUnknown ? null : 0
  if (!item || typeof item !== 'object') return unknown
  const raw =
    item.spd != null && item.spd !== ''
      ? item.spd
      : item.SPD != null && item.SPD !== ''
        ? item.SPD
        : item.speed != null && item.speed !== ''
          ? item.speed
          : item.Speed != null && item.Speed !== ''
            ? item.Speed
            : null
  if (raw === null || raw === undefined || raw === '') return unknown
  if (typeof raw === 'number') return Number.isFinite(raw) && (!preserveUnknown || raw >= 0) ? raw : unknown
  const s = String(raw).trim().replace(/,/g, '')
  const m = s.match(/-?\d+(?:\.\d+)?/)
  if (!m) return unknown
  const n = parseFloat(m[0])
  return Number.isFinite(n) && (!preserveUnknown || n >= 0) ? n : unknown
}


function pad2(n) {
  return String(n).padStart(2, '0')
}

/** 接口 utc（秒或毫秒）→ gtm 串 yyyymmdd/hhmmss */
function utcToGtmFromApi(utc) {
  if (utc == null || utc === '') return ''
  let ms = Number(utc)
  if (!Number.isFinite(ms)) return ''
  if (ms < 1e12) ms *= 1000
  const d = new Date(ms)
  if (Number.isNaN(d.getTime())) return ''
  const y = d.getFullYear()
  const m = pad2(d.getMonth() + 1)
  const day = pad2(d.getDate())
  const h = pad2(d.getHours())
  const min = pad2(d.getMinutes())
  const sec = pad2(d.getSeconds())
  return `${y}${m}${day}/${h}${min}${sec}`
}

function formatDistanceKm(value) {
  if (value == null || value === '') return '—'
  const distance = Number(value)
  if (!Number.isFinite(distance)) return '—'
  return `${distance.toFixed(distance % 1 === 0 ? 0 : 1)} km`
}

function formatWaybillTime(value) {
  if (value == null || value === '') return '—'
  if (typeof value === 'number' || /^\d{13}$/.test(String(value))) return formatGtmTime(utcToGtmFromApi(value))
  return formatGtmTime(value)
}

/**
 * 多车：firstVcl 与 others 合并；同一车牌以 others 中的记录为准（不重复展示）
 */
function mergeFirstVclWithOthers(firstVcl, others) {
  const oth = Array.isArray(others) ? others.filter(Boolean) : []
  const othersKeys = new Set(oth.map((r) => r.vno || r.vclN).filter(Boolean))
  const out = []
  if (firstVcl) {
    const k = firstVcl.vno || firstVcl.vclN
    if (!k || !othersKeys.has(k)) out.push(firstVcl)
  }
  out.push(...oth)
  return out
}

export default {
  name: 'RightDataBicycle',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isExpandedNum: {
      type: Number,
      default: 1
    },
    runRoute: {
      type: Array,
      default: () => []
    },
    waybillMode: {
      type: Boolean,
      default: false
    },
    vehicleNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      routeOverride: null,
      /** 插件 getTruckLastLocation：按 firstVcl/others + vehicleMode 展示 */
      routePayload: null,
      pageNum: 1,
      pageSize: 20
    }
  },
  computed: {
    mapPanelAnchorStyle() {
      return {
        left: this.isCollapsed ? '0' : '23rem',
        width: this.isCollapsed ? '100%' : 'calc(100% - 23rem)'
      }
    },
    panelStyle() {
      return {
        width: this.isCollapsed ? '100%' : 'calc(100% - 23rem)',
        height: this.isExpandedNum === 2 ? '100%' : 'auto',
        left: this.isCollapsed ? '0' : '23rem'
      }
    },
    /** 与 RightData.vue 标签页外层一致 */
    sectionWrapStyle() {
      return {
        position: 'relative',
        zIndex: 999,
        height: this.isExpandedNum === 1 ? '35%' : '100%',
        display: this.isExpandedNum === 3 ? 'none' : 'block'
      }
    },
    /** 与 RightData.vue 轨迹表 margin + height 一致 */
    tableCombinedStyle() {
      return {
        marginBottom: '0.625rem',
        width: '100%',
       height: this.isExpandedNum === 1 ? '9rem' : '38rem'
      }
    },
    sourceRoute() {
      if (this.routePayload) {
        const { vehicleMode, firstVcl, others } = this.routePayload
        if (vehicleMode === 'multi') {
          return mergeFirstVclWithOthers(firstVcl, others)
        }
        if (vehicleMode === 'single' && firstVcl) {
          return [firstVcl]
        }
      }
      return this.routeOverride != null ? this.routeOverride : this.runRoute
    },
    licensePlate() {
      return this.vehicleNo || ''
    },
    tableRows() {
      const route = this.sourceRoute
      if (!route || route.length === 0) return []
      return route.map((item) => {
        const hasCoord =
          item.lon != null &&
          item.lat != null &&
          !Number.isNaN(Number(item.lon)) &&
          !Number.isNaN(Number(item.lat))
        const [lng, lat] = hasCoord ? lonLatToGcjLikeTransport(item.lon, item.lat) : [NaN, NaN]
        const spd = parseRunRouteSpdKm(item, this.waybillMode)
        const dirStr = formatDirectionText(item)
        const mil = item.mil != null && item.mil !== '' ? Number(item.mil) : null
        const mileageStr =
          mil != null && Number.isFinite(mil) ? `${Number(mil.toFixed ? mil.toFixed(2) : mil)} km` : '—'
        /** 状态仅由父页面（bicyclePlugins.vue）下发 sts 决定 */
        const sts = item.sts != null && String(item.sts).trim() !== '' ? String(item.sts).trim() : '—'
        const plate = item.vno || item.vclN || item.plateNo || this.licensePlate || '—'
        return {
          _raw: item,
          _gcj: hasCoord && Number.isFinite(lng) && Number.isFinite(lat) ? { lng, lat } : null,
          plate,
          routeName: item.routeName || '—',
          waybillNo: item.waybillNo || '—',
          startUnit: item.startUnit || '—',
          endUnit: item.endUnit || '—',
          fixTime: resolveFixTimeFromItem(item),
          speed: spd == null ? '—' : `${spd.toFixed(spd % 1 === 0 ? 0 : 1)} km/h`,
          direction: dirStr,
          status: sts,
          totalMileage: formatDistanceKm(item.totalMileage),
          remainingMileage: formatDistanceKm(item.remainingMileage),
          estimatedArriveTime: formatWaybillTime(item.estimatedArriveTime),
          mileage: mileageStr,
          lngLat: hasCoord && Number.isFinite(lng) && Number.isFinite(lat) ? `${lng.toFixed(6)}, ${lat.toFixed(6)}` : '—',
          location: item.adr || item.location || '—'
        }
      })
    },
    pagedTableRows() {
      const start = (this.pageNum - 1) * this.pageSize
      return this.tableRows.slice(start, start + this.pageSize)
    }
  },
  watch: {
    runRoute: {
      handler() {
        this.routeOverride = null
      },
      deep: true
    }
  },
  methods: {
    collapsePanel(num) {
      this.$emit('collapse', num)
    },
    onSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
    },
    onPageChange(val) {
      this.pageNum = val
    },
    onTableRowClick(row) {
      this.$emit('focus-row-on-map', row)
    },
    /**
     * 接收插件页 getTruckLastLocation 结果：
     * - 多车：firstVcl 与 others 合并展示（同车牌以 others 为准）
     * - 单车：仅展示 firstVcl
     * - 其它页面：仅 runRoute
     */
    updateRouteData(data) {
      this.pageNum = 1
      if (!data) {
        this.routeOverride = null
        this.routePayload = null
        return
      }
      const emptyRun = !Array.isArray(data.runRoute) || data.runRoute.length === 0
      const hasFirst = data.firstVcl != null && typeof data.firstVcl === 'object'
      const hasOthers = Array.isArray(data.others) && data.others.length > 0
      const vm = data.vehicleMode === 'multi' ? 'multi' : data.vehicleMode === 'single' ? 'single' : null

      if (vm === 'multi' && (hasFirst || hasOthers)) {
        this.routePayload = {
          vehicleMode: 'multi',
          firstVcl: data.firstVcl,
          others: Array.isArray(data.others) ? data.others : []
        }
        this.routeOverride = null
        return
      }
      if (vm === 'single' && hasFirst) {
        this.routePayload = {
          vehicleMode: 'single',
          firstVcl: data.firstVcl,
          others: []
        }
        this.routeOverride = null
        return
      }

      this.routePayload = null
      if (data && Array.isArray(data.runRoute)) {
        this.routeOverride = [...data.runRoute]
        } else {
        this.routeOverride = []
      }
      if (emptyRun && !hasFirst && !hasOthers) {
        this.routeOverride = []
      }
    }
  }
}
</script>

<style scoped>
.right-data-bicycle-root {
  /* position: relative; */
  height: 100%;
  /* z-index: 10; */
}

/* 与 RightData.vue .trip-info-popup 一致（底对齐、圆角与内边距） */
.right-data-bicycle-root >>> .trip-info-popup {
  position: absolute;
  bottom: 0;
  border-radius: 0.25rem;
  padding: 0.4rem 0.75rem;
  z-index: 9;
  box-sizing: border-box;
}

.bicycle-tab-panel-wrap {
  display: flex;
  flex-direction: column;
  min-height: 0;
    background: #fffc;
    padding: 1rem 0.75rem 0.75rem;
  box-sizing: border-box;
    border-radius: 0.5rem;
}

.bicycle-pagination {
  margin-top: 0.5rem;
  text-align: right;
}
</style>

<!-- 与 RightData.vue 非 scoped 段对齐，限定在 .right-data-bicycle-root 内避免影响全局 -->
<style>
.right-data-bicycle-root .el-table thead th {
  font-size: 0.875rem !important;
  color: #333 !important;
}

.right-data-bicycle-root .el-table tr td {
  font-size: 0.875rem !important;
}

.right-data-bicycle-root .el-table .el-table__cell {
  padding: 0.4rem !important;
}

.right-data-bicycle-root .el-pagination .el-input__inner {
  height: 1.8rem !important;
}

.right-data-bicycle-root .el-table {
  font-size: 0.75rem;
  overflow: auto;
}

.right-data-bicycle-root .el-table th,
.right-data-bicycle-root .el-table td {
  padding: 0.375rem;
  height: 1.5rem;
  line-height: 1.5rem;
}

.right-data-bicycle-root .el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.right-data-bicycle-root .el-table__body-wrapper {
  overflow-y: auto;
}

.right-data-bicycle-root .expand-controls {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: auto;
  z-index: 99;
}

.right-data-bicycle-root .expand-controls-fiex {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 9999;
  pointer-events: none;
  box-sizing: border-box;
}

.right-data-bicycle-root .expand-controls-fiex .expand-btn {
  pointer-events: auto;
}

.right-data-bicycle-root .expand-controls-top {
  position: absolute;
  top: 0.625rem;
  left: 50%;
  transform: translateX(-50%);
}

.right-data-bicycle-root .expand-btn {
  width: 5rem;
  height: 1.2rem;
  padding: 0;
  background-color: #668bfa;
  border: none;
  border-radius: 0 0 1rem 1rem;
  -webkit-clip-path: polygon(0% 0%, 100% 0%, 92% 100%, 8% 100%);
  clip-path: polygon(0% 0%, 100% 0%, 92% 100%, 8% 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 11;
  transition: filter 0.2s ease;
  outline: none;
  text-align: center;
}

.right-data-bicycle-root .expand-controls-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 1rem 1rem 0 0;
  -webkit-clip-path: polygon(8% 0%, 92% 0%, 100% 100%, 0% 100%);
  clip-path: polygon(8% 0%, 92% 0%, 100% 100%, 0% 100%);
  z-index: 9999;
}

.right-data-bicycle-root .location-link {
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
